import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { HubTabs } from '@/types/enums';

/**
 * Core preferences ported from mobile-app/src/store/core.store.ts.
 * Drops the AsyncStorage thunks — persistence happens through `lib/storage`
 * (localStorage today, optionally `cloudStorage` later for cross-device sync).
 */
export interface CoreState {
  defaultGame: number;
  selectedGames: number[];
  activeGames: number[];
  selectedTab: HubTabs;
  currentSegments: string[];
  isCompactView: boolean;
}

const initialState: CoreState = {
  defaultGame: 0,
  selectedGames: [],
  activeGames: [],
  selectedTab: HubTabs.MIX_GAMES,
  currentSegments: [],
  isCompactView: false,
};

const coreSlice = createSlice({
  name: 'core',
  initialState,
  reducers: {
    set: (_state, action: PayloadAction<CoreState>) => action.payload,
    setDefaultGame: (state, action: PayloadAction<number>) => {
      state.defaultGame = action.payload;
    },
    setSelectedGames: (state, action: PayloadAction<number[]>) => {
      state.selectedGames = action.payload;
    },
    setActiveGames: (state, action: PayloadAction<number[]>) => {
      state.activeGames = action.payload;
    },
    setSelectedTab: (state, action: PayloadAction<HubTabs>) => {
      state.selectedTab = action.payload;
    },
    setCurrentSegments: (state, action: PayloadAction<string[]>) => {
      state.currentSegments = action.payload;
    },
    setCompactView: (state, action: PayloadAction<boolean>) => {
      state.isCompactView = action.payload;
    },
    clear: () => initialState,
  },
});

export const {
  set: setCore,
  setDefaultGame,
  setSelectedGames,
  setActiveGames,
  setSelectedTab,
  setCurrentSegments,
  setCompactView,
  clear: clearCore,
} = coreSlice.actions;

export default coreSlice.reducer;
